export { PaginationNew } from './PaginationNew';
